import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "../Reveal";

export const CTA = () => {
  return (
    <section
      data-testid="cta-section"
      className="relative z-10 py-24 md:py-32 overflow-hidden border-t border-black/10 bg-[#f4f3ee]"
    >
      <div className="absolute inset-0 grid-lines opacity-70" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <Reveal>
          <span className="font-mono-tech text-xs uppercase tracking-[0.25em] text-[#2f4bff]">
            / Let&apos;s build
          </span>
          <h2 className="mt-6 font-head text-5xl sm:text-6xl md:text-8xl font-extrabold tracking-tight leading-[0.92] max-w-4xl text-[#111111]">
            Got a legacy system?{" "}
            <span className="text-[#2f4bff]">Let&apos;s modernize it.</span>
          </h2>
          <p className="mt-8 font-body text-lg text-neutral-600 max-w-xl leading-relaxed">
            Tell me about your project. I&apos;ll reply personally with how Rye
            Software Services can help move it forward.
          </p>
          <Link
            to="/contact"
            data-testid="cta-contact-button"
            className="group mt-10 inline-flex items-center gap-3 bg-[#2f4bff] text-white font-mono-tech text-sm uppercase tracking-[0.12em] px-9 py-5 hover:bg-[#111111] transition-colors duration-300"
          >
            Contact me
            <ArrowUpRight className="h-5 w-5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};

export default CTA;
